module.exports = __webpack_public_path__ + "static/img/静止.2bd4bcb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/车辆/汽车吊/静止.png
// module id = 3egJ
// module chunks = 76